import { FORMIK_EMPTY_VALUE } from '../../../../../constants/validation'

export const LOGIN_FORM_PHONE_VERIFICATION_FIELD_NAME_CODE = 'key'

export const LOGIN_FORM_PHONE_VERIFICATION_INITIAL_VALUES = {
  [LOGIN_FORM_PHONE_VERIFICATION_FIELD_NAME_CODE]: FORMIK_EMPTY_VALUE,
}
